import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
} from '@angular/core';
import { AuthService } from '@app/shared/services/auth.service';
import { UserEmailAddressesService } from '@app/shared/services/user-email-addresses.service';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'dgx-invite-flow-modal',
    templateUrl: './invite-flow-modal.component.html',
    styleUrls: ['./invite-flow-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InviteFlowModalComponent implements OnInit {
  @Input() userEmail: string;
  @Input() verifyEmail: string;
  @Input() isMember: boolean;
  @Input() invitorKey: string;
  @Input() orgId: number;
  @Input() orgName: string;
  @Input() groupId: number;
  @Input() isSelfRegistrationEnabled: boolean;

  public learningImage = this.webEnvironmentService.getBlobUrl(
    '~/content/img/email/orginvitation/personal-learning.png'
  );

  public recommendationImage = this.webEnvironmentService.getBlobUrl(
    '~/content/img/email/orginvitation/recommendations.png'
  );

  public groupImage = this.webEnvironmentService.getBlobUrl(
    '~/content/img/email/orginvitation/discussions.png'
  );

  public isSubmitted: boolean = false;
  constructor(
    public activeModal: NgbActiveModal,
    private webEnvironmentService: WebEnvironmentService,
    private userEmailAddressesService: UserEmailAddressesService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {}

  public get header(): string {
    if(this.isSelfRegistrationEnabled) {
      return "「はたサポ！NEXT」アカウントが作成されました。登録を完了するには、もう一度ログインしてください。";
    } else {
      return this.translate.instant('orgInviteFlowModal_InviteMessageFormat', {
        orgName: this.orgName,
      });
    }
  }

  public get headerSubmitted(): string {
    return this.translate.instant('orgInviteFlowModal_VerificationSentFormat', {
      userEmail: this.userEmail,
      orgName: this.orgName,
    });
  }

  ngOnInit(): void {
    // strip escape, not sure why this is necessary, part of migration
    this.orgName = this.orgName.replace(/\\/g, '');
  }

  public submitEmailVerification() {
    this.userEmailAddressesService
      .submitForVerification(
        this.userEmail,
        this.orgId,
        this.invitorKey,
        true
      )
      .subscribe(() => {
        // when they come back from the email we want to make sure they get a new user auth
        return this.authService.refreshCacheVersionToken();
      });

    // show the updated UI immediately
    this.isSubmitted = true;
    this.cdr.detectChanges();
  }

  
}
